<template>
  <div>
    <QueryFrame 
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      :count='count'
      :current="page"
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType === 1">
            <label>门店:</label>
            <storeListSelect class="item" v-model="query.storeId" :multiple='true'></storeListSelect>
          </div>
          <div class="queryItem">
            <label>对账结果:</label>
            <lk-select v-model='query.resultType' class="item" clearable>
              <lk-option v-for="(item, index) in resultTypeList" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns">
          <lk-button class="mr8" type='primary' @click="checkAccount">医保对账</lk-button>
        </div>
        <lk-table border :columns='columns' :data='tableData'/>
      </div>
    </QueryFrame>
    <lk-modal
      v-model="modalCheckAccount"
      :footer-hide="true"
      :mask-closable="false"
      :closable="false"
      title='医保对账'
    >
      <div>
        <div style="padding-right:20%">
          <div class="modalStyle">
            <label>对账时间范围:&nbsp;&nbsp;</label>
            <timeStampDatePicker type='daterange' placeholder='请选择' class="timeInput" v-model="timeRange"></timeStampDatePicker>
          </div>
          <div class="modalStyle">
            <label>险种类型:&nbsp;&nbsp;</label>
            <lk-select v-model='insType' class="timeInput" clearable>
              <lk-option v-for="(item, index) in insTypeList" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="modalStyle">
            <label>清算类别:&nbsp;&nbsp;</label>
            <lk-select v-model='clrType' class="timeInput" clearable>
              <lk-option v-for="(item, index) in clrTypeList" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="modalStyle">
            <label>医保科目:&nbsp;&nbsp;</label>
            <lk-select v-model='insSubject' class="timeInput" clearable>
              <lk-option v-for="(item, index) in insSubjectList" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
        </div>
        <div class="btnsArea">
          <lk-button @click="cancel">取消</lk-button>
          <lk-button type="primary" @click="toCheck" style="margin-right:10px">发起对账</lk-button>
        </div>
      </div>
    </lk-modal>
    <lanZhouPrintModel ref="LanZhouPrintModel" v-show="false"></lanZhouPrintModel>
  </div>
</template>
<script>
import utils from '../../libs/utils';
import storeListSelect from '../../components/StoreListSelect.vue';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import mapState from '../../mixins/mapState';
import queryMixins from '../../mixins/queryMixins';
import healthInsManage from '../../services/healthInsManage';
import lanZhouPrintModel from '../../views/insurance/LanZhou/lanZhouPrintModel.vue'

export default {
  name: 'healthInsOrders',
  mixins: [mapState, queryMixins],
  components: {
    storeListSelect, QueryFrame, lanZhouPrintModel,
  },
  props: {},
  data() {
    return {
      query: {},
      resultTypeList: [
        {
          value: 0,
          name: '平',
        },
        {
          value: 1,
          name: '不平',
        },
      ],
      insTypeList: [
        {
          value: 310,
          name: '职工基本医疗保险',
        },
        {
          value: 320,
          name: '公务员医疗补助',
        },
        {
          value: 330,
          name: '大额医疗费用补助',
        },
        {
          value: 340,
          name: '离休人员医疗保障',
        },
        {
          value: 390,
          name: '城乡居民基本医疗保险',
        },
        {
          value: 392,
          name: '城乡居民大病医疗保险',
        },
        {
          value: 510,
          name: '生育保险',
        },
      ],
      insType: null,
      clrType: null,
      clrTypeList: [
        {
          value: 11,
          name: '门诊',
        },
        {
          value: 21,
          name: '住院',
        },
        {
          value: 41,
          name: '药店购药',
        },
        {
          value: 99902,
          name: '省本级机关清算',
        },
        {
          value: 99970,
          name: '省内异地门诊',
        },
        {
          value: 99971,
          name: '省内异地住院',
        },
        {
          value: 99972,
          name: '省内异地药店购药',
        },
        {
          value: 99,
          name: '其他',
        },
      ],
      insSubject: 0,
      insSubjectList: [
        {
          name: '省医保',
          value: 1
        },
        {
          name: '市医保',
          value: 0
        },
      ],
      timeRange: [],
      modalCheckAccount: false,
      columns: [
        {
          type: 'index',
          title: '序号',
          width: 60,
        },
        {
          title: '门店名称',
          key: 'storeName',
          minWidth: 140,
        },
        {
          title: '对账日期范围',
          key: 'dateRange',
          minWidth: 140,
        },
        {
          title: '对账结果',
          key: 'checkResult',
          minWidth: 116,
        },
        {
          title: '险种',
          key: 'insutypeName',
          minWidth: 116,
        },
        {
          title: '清算类别',
          key: 'clrTypeName',
          minWidth: 116,
        },
        {
          title: '结算经办机构',
          key: 'setlOptins',
          minWidth: 116,
        },
        {
          title: '医疗费总额',
          key: 'totalAmount',
          minWidth: 116,
        },
        {
          title: '基金支付总额',
          key: 'fundAmount',
          minWidth: 116,
        },
        {
          title: '个人账户支付总额',
          key: 'personAmount',
          minWidth: 116,
        },
        {
          title: '个人自费总额',
          key: 'personPay',
          minWidth: 116,
        },
        {
          title: '订单笔数',
          key: 'num',
          minWidth: 116,
        },
        {
          title: '操作人',
          key: 'operator',
          minWidth: 116,
        },
        {
          title: '操作时间',
          key: 'createTime',
          minWidth: 116,
        },
        {
          title: '对账说明',
          key: 'checkResult',
          minWidth: 116,
        },
        {
          title: '操作',
          fixed: 'right',
          minWidth: 116,
          render: (h, params) => h('div', [
            params.row.resultType === 1 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ path:'checkDetailAccount', query: {
                    id: params.row.id,
                    storeName: params.row.storeName || '',
                    dateRange: params.row.dateRange || '',
                    totalAmount: params.row.totalAmount || '',
                    fundAmount: params.row.fundAmount || '',
                    personAmount: params.row.personAmount || '',
                    personPay: params.row.personPay || '',
                    checkResult: params.row.checkResult || '',
                    insutype: params.row.insutype || '',
                    beginTime: params.row.beginTime || '',
                    endTime: params.row.endTime || '',
                    clrType: params.row.clrType || '',
                    medicalSubject: params.row.medicalSubject || '',
                  } });
                },
              },
            }, '明细对账') : null,
          ]),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      healthInsManage.getCheckAccountRecords(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = res.data.data.list || [];
          this.count = res.data.data.count;
          this.tableData.forEach((item) => {
            item.createTime = item.createTime ? utils.exchangeTimeToSecond(item.createTime) : '';
          });
        } else {
          this.$Message.error(res.data.error);
        };
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    toCheck() {
      this.modalCheckAccount = true;
      if (this.timeRange.length) {
        const params = {
          beginTime: this.timeRange[0],
          endTime: this.timeRange[1],
          insutype: this.insType || '',
          clrType: this.clrType || '',
          medicalSubject: this.insSubject,
        }
        healthInsManage.checkTotal(params).then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('对账成功');
            this.modalCheckAccount = false;
            this.getData();
          } else {
            this.modalCheckAccount = true;
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          this.modalCheckAccount = true;
          utils.handleError(err);
        });
      } else {
        this.$Message.error('请先选择时间范围');
        return
      };
    },
    checkAccount() {
      this.modalCheckAccount = true;
    },
    cancel() {
      this.modalCheckAccount = false;
      this.timeRange = [];
      this.insType = null;
      this.clrType = null;
    },
    handleReset() {
      this.query = {};
    },
  },
  mounted() {
    this.handleSearch();
  }
};
</script>
<style lang="less" scoped>
  .btns {
    margin-bottom: 12px;
  }
  .modalStyle {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 10px;
    width: 100%;
    .timeInput {
      width: 60%;
    }
  }
  .btnsArea {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    margin-right: 6%;
    margin-top: 20px;
  }
</style>
